// Local read-state for the derived notifications feed. Notifications are computed
// from live data (applications, bids, messages, verification); "read" is a purely
// client-side marker keyed by the stable notification id.
const KEY = "rt.notif.read";

export function getRead(): Set<string> {
  try {
    return new Set(JSON.parse(localStorage.getItem(KEY) ?? "[]") as string[]);
  } catch {
    return new Set();
  }
}

export function markRead(ids: string[]): void {
  const s = getRead();
  for (const id of ids) s.add(id);
  try {
    localStorage.setItem(KEY, JSON.stringify([...s]));
  } catch {
    /* storage unavailable — read-state is best-effort */
  }
}
